/**
 * Strips "Daily Summary" heading from markdown content
 */
export function stripDailySummaryTitle(content: string): string {
  return content.replace(/^#{1,6}\s*Daily Summary\s*\n?/im, '').trim()
}
